import Input from 'components/common/form/input/Input';
import React from 'react';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import {
  employmentTypeOptions,
  experienceOptions,
  modeOfWorkOptions,
  qualificationOptions
} from './config';
import Select from 'components/common/form/select/Select';
import Range from 'components/common/form/range/Range';
import Editor from 'components/common/form/editor/Editor';
import { Props } from './jobPostBasicForm.type';
import CheckBox from 'components/common/form/checkbox/CheckBox';
import classNames from 'classnames';

const TipFormatter = (value: number) => {
  return <span>Rs:{value.toLocaleString()}</span>;
};

function JobPostBasicForm({ isInternship, isBillable }: Props) {
  return (
    <Row className="g-5">
      <Col xs={12} xl={4}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="title">Job Title</FormLabel>
          <Input name="title" id="title" />
        </FormGroup>
      </Col>
      <Col xs={12} xl={4}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="jobLocation">Job Location</FormLabel>
          <Input name="jobLocation" id="jobLocation" />
        </FormGroup>
      </Col>
      <Col xs={12} xl={4}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="companyName">Company Name</FormLabel>
          <Input name="companyName" id="companyName" />
        </FormGroup>
      </Col>
      {!isInternship && (
        <Col xs={12} xl={3}>
          <FormGroup className="text-start">
            <FormLabel htmlFor="employmentType">Employment Type</FormLabel>
            <Select
              name="employmentType"
              id="employmentType"
              options={employmentTypeOptions}
            />
          </FormGroup>
        </Col>
      )}
      <Col xs={12} xl={3}>
        <FormGroup className="text-start">
          {isInternship ? (
            <>
              <FormLabel htmlFor="modeOfWork">Mode Of Work</FormLabel>
              <Select
                name="modeOfWork"
                id="modeOfWork"
                options={modeOfWorkOptions}
              />
            </>
          ) : (
            <>
              <FormLabel htmlFor="experience">Experience</FormLabel>
              <Select
                name="experience"
                id="experience"
                options={experienceOptions}
              />
            </>
          )}
        </FormGroup>
      </Col>
      <Col xs={12} xl={3}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="qualification">Minimum Qualification</FormLabel>
          <Select
            name="qualification"
            id="qualification"
            options={qualificationOptions}
          />
        </FormGroup>
      </Col>
      {isInternship && (
        <Col xs={12} xl={3}>
          <FormGroup className="text-start">
            <FormLabel htmlFor="internshipDuration">
              Internship Duration (Month)
            </FormLabel>
            <Input name="internshipDuration" id="internshipDuration" />
          </FormGroup>
        </Col>
      )}
      <Col xs={12} xl={3}>
        <FormGroup className="text-start">
          <div className="d-flex gap-2 align-items-center">
            <FormLabel htmlFor="salaryRange">Salary Range (Month)</FormLabel>
            {isInternship && (
              <CheckBox
                name="isBillable"
                id="isBillable"
                label="Mark as Unpaid"
              />
            )}
          </div>
          <Range
            name="salaryRange"
            id="salaryRange"
            min={5000}
            max={500000}
            tipFormatter={TipFormatter}
            alwaysShowTooltip
            tooltipPosition="bottom"
            className={classNames('mb-5', {
              'mt-0': isInternship
            })}
            disabled={isBillable}
          />
        </FormGroup>
      </Col>
      <Col xs={12}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="desc">Job Description</FormLabel>
          <Editor name="desc" id="desc" />
        </FormGroup>
      </Col>
    </Row>
  );
}

export default JobPostBasicForm;
